/* KNM-136 (folio): живой посуточный предпросмотр стоимости до сохранения брони. */
export type QuoteDay = {
  stay_date: string
  occupancy_variant: string | null
  original_price: string | null
  price: string | null
  extra_bed_qty: number
  extra_bed_price: string
  meal_type: number
  needs_manual_price: boolean
}

export type QuoteRes = {
  rate_plan: number
  rate_plan_name: string
  days: QuoteDay[]
  accommodation_subtotal: string
  capacity: {
    person_qty: number
    extra_person_qty: number
    max_capacity: number
  }
  payable_guests: number
  extra_beds: number
  has_overflow: boolean
  min_nights: number
  // Подытоги по другим тарифам — приходят, только если их запросили в alternatives.
  alternatives?: { rate_plan: number, accommodation_subtotal: string }[]
}

export type GetQuoteReq = {
  room_category: number
  rate_plan: number
  checkin: string
  checkout: string
  adults: number
  children: number
  /* id тарифов через запятую, по которым нужен только подытог: форма подбирает самый дешёвый
     одним запросом. Строкой, а не массивом: axios шлёт массив как alternatives[]=. */
  alternatives?: string
}

export const GET_QUOTE_URL = '/v2/pms/reservations/quote/'
